module.exports = __webpack_public_path__ + "img/dj.5b8460b6.png";